import {
  GET_BRANCH_REPORT_DATA_START,
  GET_BRANCH_REPORT_DATA_COMPLETE,
  GET_BRANCH_REPORT_DATA_ERROR,
  GET_AGENCY_REPORT_GRAPH_DATA_START,
  GET_AGENCY_REPORT_GRAPH_DATA_COMPLETE,
  GET_AGENCY_REPORT_GRAPH_DATA_ERROR,
  DOWNLOAD_AGENCY_REPORT_START,
  DOWNLOAD_AGENCY_REPORT_COMPLETE,
  DOWNLOAD_AGENCY_REPORT_ERROR,
  GET_BRANCH_EMPLOYEES_DATA_START,
  GET_BRANCH_EMPLOYEES_DATA_COMPLETE,
  GET_BRANCH_EMPLOYEES_DATA_ERROR,
  GET_EMPLOYEE_DETAILS_START,
  GET_EMPLOYEE_DETAILS_COMPLETE,
  GET_EMPLOYEE_DETAILS_ERROR,
  GET_CARE_COIN_TRACKER_DATA_START,
  GET_CARE_COIN_TRACKER_DATA_COMPLETE,
  GET_CARE_COIN_TRACKER_DATA_ERROR,
  SEND_CARE_COINS_START,
  SEND_CARE_COINS_COMPLETE,
  SEND_CARE_COINS_ERROR,
  CLEAR_REPORTING_ERRORS,
  GET_SEARCH_EMPLOYEES_DATA_START,
  GET_SEARCH_EMPLOYEES_DATA_COMPLETE,
  GET_SEARCH_EMPLOYEES_DATA_ERROR,
  CLEAR_SEARCH_DATA,
  SET_EMPLOYEE_DATA,
  CLEAR_EMPLOYEE_DATA,
  EMPLOYEE_EARNING_FETCH,
  EMPLOYEE_EARNING_FETCH_COMPLETE,
  EMPLOYEE_EARNING_FETCH_ERROR,
  RETRY_REDEEM_REWARD_START,
  RETRY_REDEEM_REWARD_COMPLETE,
  RETRY_REDEEM_REWARD_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  isFetchBranchReportStarted: false,
  branchReportData: undefined,
  branchReportError: undefined,
  isFetchBranchEmployeesStarted: false,
  branchEmployeesData: undefined,
  branchEmployeesError: undefined,
  isFetchEmployeesDeatilsStarted: false,
  employeeFetchError: undefined,
  employeeData: undefined,
  sendCareCoinsError: undefined,
  isSendCareCoinsStarted: false,
  fetchEmployeeEarningStarted: false,
  employeeEarningData: [],
  employeeEarningError: null,
  employeeEarningTotalRecord: null,
  retryRedeemRewardSuceess: false,
  retryRedeemRewardError: undefined,
  isFetchAgencyReportGraphStarted: false,
  agencyReportGraphData: [],
  agencyReportGraphAvgEarning: 0,
  agencyReportGraphAvgRedemption: 0,
  agencyReportGraphError: undefined,
  isDownloadAgencyReportStarted: false,
  downloadAgencyReportError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_BRANCH_REPORT_DATA_START:
      return {
        ...state,
        isFetchBranchReportStarted: true,
        branchReportError: undefined,
        branchReportData: undefined,
      };
    case GET_BRANCH_REPORT_DATA_COMPLETE:
      return {
        ...state,
        branchReportData: payload.data,
        totalRecords: payload.totalRecords,
        totalPages: payload.totalPages,
        isFetchBranchReportStarted: false,
        branchReportError: undefined,
      };
    case GET_BRANCH_REPORT_DATA_ERROR:
      return {
        ...state,
        branchReportError: payload.error,
        isFetchBranchReportStarted: false,
        branchReportData: undefined,
      };
    case GET_AGENCY_REPORT_GRAPH_DATA_START:
      return {
        ...state,
        isFetchAgencyReportGraphStarted: true,
        agencyReportGraphError: undefined,
      };
    case GET_AGENCY_REPORT_GRAPH_DATA_COMPLETE:
      return {
        ...state,
        isFetchAgencyReportGraphStarted: false,
        agencyReportGraphData: payload.data || [],
        agencyReportGraphAvgEarning: Number(payload.avgEarning || 0),
        agencyReportGraphAvgRedemption: Number(payload.avgRedemption || 0),
        agencyReportGraphDurationFilter: payload.durationFilter,
        agencyReportGraphError: undefined,
      };
    case GET_AGENCY_REPORT_GRAPH_DATA_ERROR:
      return {
        ...state,
        isFetchAgencyReportGraphStarted: false,
        agencyReportGraphData: [],
        agencyReportGraphAvgEarning: 0,
        agencyReportGraphAvgRedemption: 0,
        agencyReportGraphError: payload.error,
      };
    case DOWNLOAD_AGENCY_REPORT_START:
      return {
        ...state,
        isDownloadAgencyReportStarted: true,
        downloadAgencyReportError: undefined,
      };
    case DOWNLOAD_AGENCY_REPORT_COMPLETE:
      return {
        ...state,
        isDownloadAgencyReportStarted: false,
        downloadAgencyReportError: undefined,
      };
    case DOWNLOAD_AGENCY_REPORT_ERROR:
      return {
        ...state,
        isDownloadAgencyReportStarted: false,
        downloadAgencyReportError: payload.error,
      };
    case GET_BRANCH_EMPLOYEES_DATA_START:
      return {
        ...state,
        isFetchBranchEmployeesStarted: true,
        branchEmployeesError: undefined,
        branchEmployeesData: undefined,
      };
    case GET_BRANCH_EMPLOYEES_DATA_COMPLETE:
      return {
        ...state,
        branchEmployeesData: payload.data,
        employeesTotalRecords: payload.totalRecords,
        employeesTotalPages: payload.totalPages,
        isFetchBranchEmployeesStarted: false,
        branchEmployeesError: undefined,
      };
    case GET_BRANCH_EMPLOYEES_DATA_ERROR:
      return {
        ...state,
        branchEmployeesError: payload.error,
        isFetchBranchEmployeesStarted: false,
        branchEmployeesData: undefined,
      };
    case GET_EMPLOYEE_DETAILS_START:
      return {
        ...state,
        isFetchEmployeesDeatilsStarted: true,
        employeeFetchError: undefined,
        employeeData: undefined,
      };
    case GET_EMPLOYEE_DETAILS_COMPLETE:
      return {
        ...state,
        employeeData: payload.data,
        productivityIndicator: payload.legend,
        isFetchEmployeesDeatilsStarted: false,
        employeeFetchError: undefined,
      };
    case GET_EMPLOYEE_DETAILS_ERROR:
      return {
        ...state,
        employeeFetchError: payload.error,
        isFetchEmployeesDeatilsStarted: false,
        employeeData: undefined,
      };
    case GET_CARE_COIN_TRACKER_DATA_START:
      return {
        ...state,
        isFetchCareCoinTrackerStarted: true,
        careCoinTrackerError: undefined,
        careCoinTrackerData: undefined,
      };
    case GET_CARE_COIN_TRACKER_DATA_COMPLETE:
      return {
        ...state,
        careCoinTrackerData: payload.data,
        careCoinTrackerTotalRecords: payload.totalRecords,
        careCoinTrackerTotalPages: payload.totalPages,
        isFetchCareCoinTrackerStarted: false,
        careCoinTrackerError: undefined,
      };
    case GET_CARE_COIN_TRACKER_DATA_ERROR:
      return {
        ...state,
        careCoinTrackerError: payload.error,
        isFetchCareCoinTrackerStarted: false,
        careCoinTrackerData: undefined,
      };
    case SEND_CARE_COINS_START:
      return {
        ...state,
        isSendCareCoinsStarted: true,
        sendCareCoinsError: undefined,
      };
    case SEND_CARE_COINS_COMPLETE:
      return {
        ...state,
        isSendCareCoinsStarted: false,
        sendCareCoinsError: undefined,
      };
    case SEND_CARE_COINS_ERROR:
      return {
        ...state,
        sendCareCoinsError: payload.error,
        isSendCareCoinsStarted: false,
      };
    case GET_SEARCH_EMPLOYEES_DATA_START:
      return {
        ...state,
        isFetchSearchDataStarted: true,
        searchDataError: undefined,
        searchData: undefined,
      };
    case GET_SEARCH_EMPLOYEES_DATA_COMPLETE:
      return {
        ...state,
        isFetchSearchDataStarted: false,
        searchDataError: undefined,
        searchData: payload.data,
      };
    case GET_SEARCH_EMPLOYEES_DATA_ERROR:
      return {
        ...state,
        searchDataError: payload.error,
        isFetchSearchDataStarted: false,
        searchData: undefined,
      };
    case SET_EMPLOYEE_DATA:
      return {
        ...state,
        employeeDetailsData: payload.data,
      };
    case CLEAR_EMPLOYEE_DATA:
      return {
        ...state,
        employeeDetailsData: undefined,
      };
    case CLEAR_SEARCH_DATA:
      return {
        ...state,
        searchData: undefined,
        searchDataError: undefined,
      };
    case CLEAR_REPORTING_ERRORS:
      return {
        ...state,
        sendCareCoinsError: undefined,
      };
    case EMPLOYEE_EARNING_FETCH:
      return {
        ...state,
        fetchEmployeeEarningStarted: true,
        retryRedeemRewardSuceess: false,
        retryRedeemRewardError: false,
        employeeEarningError: null, // Reset error on new fetch
        employeeEarningData: [], // Reset stale data so a previous caregiver's rows never show
        totalRecords: 0,
        totalPages: 0,
      };
    case EMPLOYEE_EARNING_FETCH_COMPLETE:
      return {
        ...state,
        fetchEmployeeEarningStarted: false,
        employeeEarningData: payload.data,
        totalRecords: payload.totalRecords,
        totalPages: payload.totalPages,
      };
    case EMPLOYEE_EARNING_FETCH_ERROR:
      return {
        ...state,
        fetchEmployeeEarningStarted: false,
        employeeEarningError: payload.error,
        employeeEarningData: [], // Clear stale data so a failed fetch never shows a prior caregiver's rows
        totalRecords: 0,
        totalPages: 0,
      };
    case RETRY_REDEEM_REWARD_START:
      return {
        ...state,
        isRetryRedeemRewardStarted: true,
        retryRedeemRewardError: undefined,
        retryRedeemRewardSuceess: false,
      };
    case RETRY_REDEEM_REWARD_COMPLETE:
      return {
        ...state,
        isRetryRedeemRewardStarted: false,
        retryRedeemRewardError: undefined,
        retryRedeemRewardSuceess: true,
      };
    case RETRY_REDEEM_REWARD_ERROR:
      return {
        ...state,
        retryRedeemRewardError: payload.error,
        isRetryRedeemRewardStarted: false,
        retryRedeemRewardSuceess: false,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
